import { Alert, Button, TextField } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../provider/AuthProvider";
import { loginAdmin } from "../../services/adminService";

export default function AdminLoginPage() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setAccessToken } = useAuth();

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if (!login || !password) {
      setError("Vyplňte prosím odběratelské číslo a heslo.");
      return;
    }
    setError("");

    const result = await loginAdmin(login, password);
    if (result.success) {
      setAccessToken(result.token);
      navigate("/admin/users");
    } else {
      setError(result.message);
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "0 auto" }}>
      <h2>Admin přihlášení</h2>
      <form onSubmit={handleLoginSubmit}>
        {error && (
          <Alert severity="error" style={{ marginBottom: "10px" }}>
            {error}
          </Alert>
        )}
        <div style={{ marginBottom: "10px" }}>
          <TextField
            id="subscriberNumber"
            label="Login"
            variant="outlined"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            fullWidth
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <TextField
            id="password"
            label="Heslo"
            type="password"
            variant="outlined"
            value={password}
            autoComplete="off"
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
        </div>
        <Button
          type="submit"
          variant="contained"
          style={{ display: "block", margin: "0px auto", width: "150px" }}
        >
          Přihlásit se
        </Button>
        <Button
          variant="outlined"
          style={{ display: "block", margin: "5px auto", width: "150px" }}
          onClick={() => navigate("/login")}
        >
          Zpět na hlavní
        </Button>
      </form>
    </div>
  );
}
